export const development_url = "https://wfapi.wolfwinplay.in";
export const production_url = "https://wfapi.wolfwinplay.in";
export const local_url = "http://192.168.1.11:5005";

export const isLocal = false;

let API_URL;

if (isLocal) {
    API_URL = local_url;
} else {
    const envType = localStorage.getItem("envType") || "0";
    API_URL = envType === "0" ? development_url : production_url;
}

export { API_URL };
